import script from "./SplashPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SplashPage.vue?vue&type=script&setup=true&lang=js"

import "./SplashPage.vue?vue&type=style&index=0&id=13f5a2f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13f5a2f4"]])

export default __exports__